// extracted by mini-css-extract-plugin
export default {"mainLayout":"AppLayoutStyles_mainLayout__4i92i","layout":"AppLayoutStyles_layout__+mXc2"};